module.exports = __webpack_public_path__ + "static/media/custom-content.ad411f3f.png";